import { useState } from 'react';
import { AuthService } from '../../services';
import { timeoutFunc } from '../../utils/commonUtils';
import commonMessage from '../../configs/commonMessage';

let timeout = 0;

const useIsPhoneNumberRegistered = () => {
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(null);
  const [isNotValidPhoneNumberMessage, setIsNotValidPhoneNumberMessage] =
    useState(null);
  const [isValidatingPhoneNumber, setIsValidatingPhoneNumber] = useState(false);

  const onValidate = ({ phoneNumber }) => {
    if (phoneNumber === '') {
      setIsNotValidPhoneNumberMessage(
        commonMessage.invalidType('phone number')
      );
      setIsValidPhoneNumber(false);
    }

    if (phoneNumber !== '') {
      setIsNotValidPhoneNumberMessage(
        commonMessage.invalidType('phone number')
      );
      setIsValidPhoneNumber(false);
    }

    timeout = timeoutFunc(
      timeout,
      () => {
        if (phoneNumber !== '') {
          setIsValidatingPhoneNumber(true);
          setIsNotValidPhoneNumberMessage(null);
          AuthService.postPhoneNumberAvailability({
            phone_number: phoneNumber,
          })
            .then(() => {
              setIsNotValidPhoneNumberMessage('Phone number is not registered');
              setIsValidPhoneNumber(false);
            })
            .catch(() => {
              setIsNotValidPhoneNumberMessage(null);
              setIsValidPhoneNumber(true);
            })
            .finally(() => {
              setIsValidatingPhoneNumber(false);
            });
        }
      },
      2000
    );
  };

  const validateStatus = () => {
    if (isValidatingPhoneNumber) {
      return 'validating';
    }
    if (
      !isValidatingPhoneNumber &&
      isValidPhoneNumber &&
      isValidPhoneNumber !== null
    ) {
      return 'success';
    }
    if (
      !isValidatingPhoneNumber &&
      !isValidPhoneNumber &&
      isValidPhoneNumber !== null
    ) {
      return 'error';
    }
    return '';
  };

  return {
    isValidPhoneNumber,
    isNotValidPhoneNumberMessage,
    isValidatingPhoneNumber,
    onValidate,
    validateStatus,
  };
};

const useIsPhoneNumberAlreadyRegistered = () => {
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(null);
  const [isNotValidPhoneNumberMessage, setIsNotValidPhoneNumberMessage] =
    useState(null);
  const [isValidatingPhoneNumber, setIsValidatingPhoneNumber] = useState(false);

  const onValidate = ({ phoneNumber, initialPhoneNumber }) => {
    if (phoneNumber === '') {
      setIsNotValidPhoneNumberMessage(
        commonMessage.invalidType('phone number')
      );
      setIsValidPhoneNumber(false);
    }

    if (phoneNumber !== initialPhoneNumber) {
      timeout = timeoutFunc(
        timeout,
        () => {
          if (phoneNumber !== '' && phoneNumber) {
            setIsValidatingPhoneNumber(true);
            setIsNotValidPhoneNumberMessage(null);
            AuthService.postPhoneNumberAvailability({
              phone_number: phoneNumber,
            })
              .then(() => {
                setIsNotValidPhoneNumberMessage(null);
                setIsValidPhoneNumber(true);
              })
              .catch(() => {
                setIsNotValidPhoneNumberMessage(
                  'Phone number is already registered.'
                );
                setIsValidPhoneNumber(false);
              })
              .finally(() => {
                setIsValidatingPhoneNumber(false);
              });
          }
        },
        2000
      );
    } else {
      setIsNotValidPhoneNumberMessage(null);
      setIsValidPhoneNumber(true);
    }
  };

  const validateStatus = () => {
    if (isValidatingPhoneNumber) {
      return 'validating';
    }
    if (
      !isValidatingPhoneNumber &&
      isValidPhoneNumber &&
      isValidPhoneNumber !== null
    ) {
      return 'success';
    }
    if (
      !isValidatingPhoneNumber &&
      !isValidPhoneNumber &&
      isValidPhoneNumber !== null
    ) {
      return 'error';
    }
    return '';
  };

  return {
    isValidPhoneNumber,
    isNotValidPhoneNumberMessage,
    isValidatingPhoneNumber,
    onValidate,
    validateStatus,
  };
};

export default {
  useIsPhoneNumberAlreadyRegistered,
  useIsPhoneNumberRegistered,
};
